import React from "react";
import { FpCenter, FpContainer, FpLoader } from "./FullPageLoaderStyles";

function FullPageLoader() {
  return (
    <FpContainer>
      <FpCenter>
        <FpLoader>
          <span />
          <span />
          <span />
        </FpLoader>
      </FpCenter>
    </FpContainer>
  );
}

export default FullPageLoader;
